export default "__VITE_ASSET__Chs0byLY__"